import { API_PREFIX, paginatedFromDto, type HttpClient } from "@nasam/kernel";
import type { NotificationsRepository } from "../domain";
import {
  deviceTokenWriteDtoSchema,
  notificationListResponseDtoSchema,
  notificationResponseDtoSchema,
  notificationsSummaryResponseDtoSchema,
} from "./notificationDtos";
import {
  notificationFromDto,
  notificationsSummaryFromDto,
} from "./notificationMappers";

const NOTIFICATIONS_PATH = `${API_PREFIX}/notifications`;

export function createNotificationsHttpRepository(
  http: HttpClient,
): NotificationsRepository {
  return {
    async list(query) {
      const response = await http.get(NOTIFICATIONS_PATH, { params: query });
      return paginatedFromDto(
        notificationListResponseDtoSchema.parse(response),
        notificationFromDto,
      );
    },
    async summary() {
      const response = await http.get(`${NOTIFICATIONS_PATH}/summary`);
      return notificationsSummaryFromDto(
        notificationsSummaryResponseDtoSchema.parse(response).data,
      );
    },
    async markAsRead(id) {
      const response = await http.patch(`${NOTIFICATIONS_PATH}/${id}/read`);
      return notificationFromDto(
        notificationResponseDtoSchema.parse(response).data,
      );
    },
    async markAllAsRead() {
      await http.post(`${NOTIFICATIONS_PATH}/read-all`);
    },
    async registerDevice(input) {
      const body = deviceTokenWriteDtoSchema.parse(input);
      await http.post(`${NOTIFICATIONS_PATH}/devices`, body);
    },
    async unregisterDevice(token) {
      await http.delete(
        `${NOTIFICATIONS_PATH}/devices/${encodeURIComponent(token)}`,
      );
    },
  };
}
